export default __webpack_public_path__ + "static/media/94.7c29a102.gif";